(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mana-community-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mana-community-reviews')) {
  customElements.define('mana-community-reviews', class extends HTMLElement {
    static locks = 0;
    static savedOverflow = '';
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('.mr-form');
      this.frame = this.querySelector('[data-mr-response]');
      this.error = this.querySelector('[data-mr-error]');
      this.status = this.querySelector('[data-mr-status]');
      this.submit = this.querySelector('[type=submit]');
      this.radios = [...this.querySelectorAll('.mr-star-label input')];
      this.photo = this.querySelector('[data-mr-photo]');
      this.photoLink = this.querySelector('[data-mr-photo-url]');
      this.photoStatus = this.querySelector('[data-mr-photo-status]');
      this.photoPreview = this.querySelector('[data-mr-photo-preview]');
      this.photoThumb = this.querySelector('[data-mr-photo-thumb]');
      this.photo.addEventListener('change', () => this.uploadPhoto(), options);
      this.querySelector('[data-mr-photo-remove]').addEventListener('click', () => {if (!this.pending) this.resetPhoto();}, options);
      this.querySelector('[data-mr-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-mr-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {this.unlock(); this.opener?.focus();}, options);
      this.form.addEventListener('input', event => {
        if (event.target.matches('input,textarea')) event.target.removeAttribute('aria-invalid');
        if (event.target.type === 'radio') this.paintStars(Number(event.target.value));
      }, options);
      this.form.addEventListener('invalid', event => {
        event.target.setAttribute('aria-invalid', 'true');
        this.showError(this.dataset.validation, false);
      }, {capture: true, signal: this.events.signal});
      this.radios.forEach((radio, index) => {
        radio.closest('label').addEventListener('pointerenter', () => this.paintStars(index + 1), options);
      });
      this.querySelector('.mr-star-inputs').addEventListener('pointerleave', () => this.paintStars(Number(this.radios.find(radio => radio.checked)?.value || 0)), options);
      this.form.addEventListener('submit', event => {
        if (this.pending) return;
        if (this.uploadingPhoto) {event.preventDefault(); return;}
        if (!this.form.checkValidity()) {event.preventDefault(); this.form.reportValidity(); return;}
        this.pending = true;
        this.photo.disabled = true;
        this.error.hidden = true;
        this.status.textContent = this.dataset.wait;
        this.status.hidden = false;
        this.form.setAttribute('aria-busy', 'true');
        this.submit.disabled = true;
        this.timer = setTimeout(() => {
          if (this.pending) this.status.textContent = this.dataset.failure;
        }, 90000);
      }, options);
      this.frame.addEventListener('load', () => this.response(), options);
      this.paintStars(0);
    }
    open() {
      this.opener = document.activeElement;
      if (this.dialog.open) return;
      this.dialog.showModal();
      if (!this.locked) {
        if (this.constructor.locks++ === 0) {
          this.constructor.savedOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        this.locked = true;
      }
      const focus = this.querySelector('[data-mr-success]:not([hidden])') || this.querySelector('[data-mr-first]');
      focus?.focus();
    }
    unlock() {
      if (!this.locked) return;
      this.locked = false;
      if (--this.constructor.locks === 0) document.body.style.overflow = this.constructor.savedOverflow;
    }
    paintStars(rating) {
      this.radios.forEach((radio, index) => {radio.nextElementSibling.textContent = index < rating ? '★' : '☆';});
    }
    showError(message, focus = true) {
      this.error.textContent = message;
      this.error.hidden = false;
      if (focus) this.error.focus();
    }
    response() {
      if (!this.pending) return;
      try {
        const doc = this.frame.contentDocument;
        const url = new URL(this.frame.contentWindow.location.href);
        if (url.protocol === 'about:') return;
        if (url.searchParams.get('contact_posted') === 'true' || doc.querySelector('[data-mr-native-success]')) {
          this.pending = false;
          clearTimeout(this.timer);
          this.querySelector('[data-mr-form-panel]').hidden = true;
          this.frame.hidden = true;
          const success = this.querySelector('[data-mr-success]');
          success.hidden = false;
          if (this.dialog.open) success.focus();
          return;
        }
        if (url.pathname.includes('/challenge')) {
          this.form.hidden = true;
          this.frame.hidden = false;
          this.frame.focus();
          return;
        }
        const error = doc.querySelector('[data-mr-native-errors],.contact-form .errors,.form-status-list,.errors');
        this.fail(error?.textContent?.trim() || this.dataset.failure);
      } catch {
        this.form.hidden = true;
        this.frame.hidden = false;
        this.frame.focus();
      }
    }
    fail(message) {
      this.pending = false;
      this.photo.disabled = false;
      clearTimeout(this.timer);
      this.form.hidden = false;
      this.frame.hidden = true;
      this.form.removeAttribute('aria-busy');
      this.submit.disabled = false;
      this.status.hidden = true;
      this.showError(message);
    }
    resetPhoto() {
      this.photoGeneration = (this.photoGeneration || 0) + 1;
      this.photoAbort?.abort();
      this.photoAbort = null;
      if (this.photoObjectUrl) URL.revokeObjectURL(this.photoObjectUrl);
      this.photoObjectUrl = null;
      this.photo.value = '';
      this.photo.setCustomValidity('');
      this.photo.removeAttribute('aria-invalid');
      this.photoLink.value = '';
      this.photoStatus.hidden = true;
      this.photoStatus.removeAttribute('data-error');
      this.photoPreview.hidden = true;
      this.photoThumb.hidden = true;
      this.photoThumb.removeAttribute('src');
      this.uploadingPhoto = false;
      if (!this.pending) this.submit.disabled = false;
    }
    async uploadPhoto() {
      const file = this.photo.files?.[0];
      if (!file) {this.resetPhoto(); return;}
      const generation = this.photoGeneration = (this.photoGeneration || 0) + 1;
      this.photoAbort?.abort();
      if (this.photoObjectUrl) URL.revokeObjectURL(this.photoObjectUrl);
      this.photoLink.value = '';
      this.photoStatus.hidden = false;
      this.photoStatus.removeAttribute('data-error');
      this.photoPreview.hidden = false;
      this.photoThumb.hidden = true;
      this.uploadingPhoto = true;
      this.submit.disabled = true;
      this.photo.setCustomValidity(this.dataset.photoUploading);
      this.photoStatus.textContent = this.dataset.photoUploading;
      const uploadAbort = this.photoAbort = new AbortController();
      const timeout = setTimeout(() => uploadAbort.abort(), 45000);
      try {
        if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) throw new Error(this.dataset.photoInvalid);
        const bitmap = await createImageBitmap(file);
        const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(bitmap.width * scale));
        canvas.height = Math.max(1, Math.round(bitmap.height * scale));
        const context = canvas.getContext('2d');
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        bitmap.close();
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', .82));
        if (!blob || blob.size > 2 * 1024 * 1024) throw new Error(this.dataset.photoInvalid);
        if (generation !== this.photoGeneration) return;
        this.photoObjectUrl = URL.createObjectURL(blob);
        this.photoThumb.src = this.photoObjectUrl;
        this.photoThumb.hidden = false;
        const response = await fetch('https://mana-waitlist-counter.albini11.chatgpt.site/api/review-photos', {
          method:'POST', headers:{'Content-Type':'image/jpeg'}, body:blob, signal:uploadAbort.signal, credentials:'omit'
        });
        const result = await response.json();
        if (!response.ok || typeof result.url !== 'string') throw new Error(result.error || this.dataset.photoError);
        const url = new URL(result.url);
        if (url.origin !== 'https://mana-waitlist-counter.albini11.chatgpt.site' || !/^\/api\/review-photos\/[a-f0-9]{64}$/.test(url.pathname)) throw new Error(this.dataset.photoError);
        if (generation !== this.photoGeneration) return;
        this.photoLink.value = result.url;
        this.photo.setCustomValidity('');
        this.photo.removeAttribute('aria-invalid');
        this.photoStatus.textContent = this.dataset.photoReady;
      } catch (error) {
        if (generation !== this.photoGeneration) return;
        const message = error.name === 'AbortError' ? this.dataset.photoError : (error.message || this.dataset.photoError);
        this.photo.value = '';
        this.photoStatus.textContent = message;
        this.photoStatus.setAttribute('data-error', '');
        this.photo.setAttribute('aria-invalid', 'true');
        this.photo.setCustomValidity(message);
      } finally {
        clearTimeout(timeout);
        if (generation === this.photoGeneration) {
          this.uploadingPhoto = false;
          if (!this.pending) this.submit.disabled = false;
        }
      }
    }

    disconnectedCallback() {
      this.photoGeneration = (this.photoGeneration || 0) + 1;
      this.photoAbort?.abort();
      if (this.photoObjectUrl) URL.revokeObjectURL(this.photoObjectUrl);
      clearTimeout(this.timer);
      this.events?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mana-scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mana-scroll-story')) {
    class ManaScrollStory extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.cleanups = [];
        this.chapters = [...this.querySelectorAll('.mana-chapter')];
        this.buttons = [...this.querySelectorAll('[data-go]')];
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.canvas = this.querySelector('canvas');
        this.scene = this.querySelector('.mana-scene');
        this.thread = this.querySelector('.mana-thread');
        this.threadPaths = [...this.thread.querySelectorAll('path')];
        this.threadPaths.forEach(path => path.setAttribute('pathLength','1000'));
        this.writing = this.querySelector('.mana-thread-writing path');
        this.reveal = this.querySelector('.mana-reveal');
        this.index = -1;
        this.progress = 0;
        this.frame = 0;
        this.listen(this.motion, 'change', () => this.configure());
        this.listen(document, 'scroll', () => this.schedule(), true);
        this.listen(window, 'resize', () => this.resize());
        this.listen(document, 'shopify:block:select', event => {
          const i = this.chapters.findIndex(chapter => chapter.dataset.blockId === event.detail.blockId);
          if (i >= 0) this.go(i);
        });
        this.buttons.forEach(button => this.listen(button, 'click', () => this.go(Number(button.dataset.go))));
        this.listen(this.querySelector('.mana-next'), 'click', () => this.index < this.chapters.length - 1 ? this.go(this.index + 1) : document.getElementById(`ManaAfter-${this.dataset.sectionId}`).scrollIntoView({behavior:this.motion.matches ? 'instant' : 'smooth'}));
        this.observer = new ResizeObserver(() => this.resize());
        this.observer.observe(this.querySelector('.mana-stage'));
        this.configure();
      }
      listen(target, event, action, options) {
        target.addEventListener(event, action, options);
        this.cleanups.push(() => target.removeEventListener(event, action, options));
      }
      configure() {
        if (this.motion.matches || this.chapters.length < 2) return this.staticView();
        if (!this.gl) {
          try { this.initGL(); }
          catch { return this.staticView(); }
        }
        this.classList.add('is-ready');
        this.resize();
      }
      staticView() {
        this.classList.remove('is-ready');
        this.activate(this.chapters.length - 1);
        if (this.reveal) this.reveal.style.opacity = '1';
      }
      initGL() {
        const gl = this.canvas.getContext('webgl2', {alpha:true, antialias:true, powerPreference:'low-power'});
        if (!gl) throw new Error('WebGL unavailable');
        this.gl = gl;
        this.listen(this.canvas, 'webglcontextlost', event => {event.preventDefault();this.staticView();});
        const vertex = `#version 300 es
          precision highp float;
          layout(location=0) in vec3 vertex;
          layout(location=1) in vec3 normal;
          layout(location=2) in vec4 bead;
          uniform float aspect;
          uniform float yaw;
          uniform float tilt;
          out vec3 n;
          out vec3 v;
          void main(){
            float a=float(gl_InstanceID)*1.27;
            mat3 spin=mat3(cos(a),0.,-sin(a),0.,1.,0.,sin(a),0.,cos(a));
            mat3 ry=mat3(cos(yaw),0.,-sin(yaw),0.,1.,0.,sin(yaw),0.,cos(yaw));
            mat3 rz=mat3(cos(tilt),sin(tilt),0.,-sin(tilt),cos(tilt),0.,0.,0.,1.);
            vec3 world=rz*ry*(spin*vertex*bead.w+bead.xyz);
            n=normalize(rz*ry*spin*normal);
            v=vec3(0.,0.,13.)-world;
            float depth=13.-world.z;
            float focal=3.6;
            gl_Position=vec4(world.x*focal/aspect,world.y*focal,depth*.98-.2,depth);
          }`;
        const fragment = `#version 300 es
          precision highp float;
          in vec3 n;
          in vec3 v;
          uniform vec3 colour;
          out vec4 outColour;
          void main(){
            vec3 N=normalize(n),V=normalize(v),L=normalize(vec3(-3.,5.,6.));
            float light=max(dot(N,L),0.);
            float spec=pow(max(dot(N,normalize(L+V)),0.),55.);
            float rim=pow(1.-max(dot(N,V),0.),3.);
            vec3 R=reflect(-V,N);
            float windowLight=smoothstep(.68,.82,R.y)*smoothstep(-.9,-.55,R.x)*(1.-smoothstep(.45,.7,R.x));
            float strip=pow(max(0.,1.-abs(R.x+.47)*8.),10.)*smoothstep(-.1,.5,R.y);
            vec3 base=colour*(.4+light*.95)+vec3(.15,.09,.23)*rim;
            vec3 lit=base+vec3(1.,.93,.85)*(spec*.9+windowLight*.42+strip*.25)+vec3(.38,.24,.57)*rim*.45;
            outColour=vec4(pow(lit,vec3(.8)),1.);
          }`;
        const shader = (type, source) => {const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error('Shader unavailable');return s;};
        const vs=shader(gl.VERTEX_SHADER,vertex),fs=shader(gl.FRAGMENT_SHADER,fragment);
        this.program=gl.createProgram();gl.attachShader(this.program,vs);gl.attachShader(this.program,fs);gl.linkProgram(this.program);gl.deleteShader(vs);gl.deleteShader(fs);
        if(!gl.getProgramParameter(this.program,gl.LINK_STATUS))throw new Error('Renderer unavailable');
        gl.useProgram(this.program);
        const verts=[];
        const unit=(lat,lon)=>[Math.sin(lat)*Math.cos(lon),Math.cos(lat),Math.sin(lat)*Math.sin(lon)];
        const tri=(a,b,c)=>{
          const u=b.map((x,i)=>x-a[i]),v=c.map((x,i)=>x-a[i]);
          let n=[u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]];
          const len=Math.hypot(...n);if(len<.00001)return;n=n.map(x=>x/len);
          const center=a.map((x,i)=>(x+b[i]+c[i])/3);if(n.reduce((sum,x,i)=>sum+x*center[i],0)<0)n=n.map(x=>-x);
          for(const p of [a,b,c])verts.push(...p,...n);
        };
        for(let y=0;y<9;y++)for(let x=0;x<14;x++){
          const a=unit(y*Math.PI/9,x*2*Math.PI/14),b=unit((y+1)*Math.PI/9,x*2*Math.PI/14),c=unit((y+1)*Math.PI/9,(x+1)*2*Math.PI/14),d=unit(y*Math.PI/9,(x+1)*2*Math.PI/14);
          tri(a,b,c);tri(a,c,d);
        }
        this.vertexCount=verts.length/6;
        this.geometry=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,this.geometry);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(verts),gl.STATIC_DRAW);
        gl.enableVertexAttribArray(0);gl.vertexAttribPointer(0,3,gl.FLOAT,false,24,0);gl.enableVertexAttribArray(1);gl.vertexAttribPointer(1,3,gl.FLOAT,false,24,12);
        this.points=[];
        for(let face=0;face<2;face++)for(let y=0;y<15;y++)for(let x=0;x<25;x++)this.points.push([(x-12)*.177,(y-7)*.177-.63,face===0?.5:-.5,0]);
        for(let side=0;side<2;side++)for(let y=0;y<15;y++)for(let z=1;z<6;z++)this.points.push([(side===0?-12:12)*.177,(y-7)*.177-.63,-.5+z/6,0]);
        for(let i=0;i<35;i++)for(let j=0;j<3;j++){const a=Math.PI*i/34;this.points.push([Math.cos(a)*1.8,.86+Math.sin(a)*1.65,(j-1)*.165,1]);}
        this.data=new Float32Array(this.points.length*4);this.instances=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,this.instances);gl.bufferData(gl.ARRAY_BUFFER,this.data,gl.DYNAMIC_DRAW);gl.enableVertexAttribArray(2);gl.vertexAttribPointer(2,4,gl.FLOAT,false,16,0);gl.vertexAttribDivisor(2,1);
        this.uniform={};for(const name of ['aspect','yaw','tilt','colour'])this.uniform[name]=gl.getUniformLocation(this.program,name);
        gl.enable(gl.DEPTH_TEST);gl.clearColor(0,0,0,0);
      }
      resize() {
        const header=document.getElementById('header-component');
        const sticky=header && getComputedStyle(header).position==='sticky';
        const headerWrapper=header?.closest('.shopify-section');
        const offset=sticky || (headerWrapper && getComputedStyle(headerWrapper).position==='sticky') ? header.getBoundingClientRect().height : 0;
        this.style.setProperty('--mana-top',`${Math.round(offset)}px`);
        this.topOffset=offset;
        if(this.gl){const rect=this.canvas.getBoundingClientRect(),dpr=Math.min(devicePixelRatio||1,1.7);this.canvas.width=Math.max(1,Math.round(rect.width*dpr));this.canvas.height=Math.max(1,Math.round(rect.height*dpr));this.gl.viewport(0,0,this.canvas.width,this.canvas.height);}
        this.layoutThread();
        this.schedule();
      }

      layoutThread() {
        if(!this.writing)return;
        const stage=this.querySelector('.mana-stage').getBoundingClientRect(),origin=this.querySelector('.mana-thread-origin').getBoundingClientRect();
        const mobile=stage.width<750,w=stage.width,h=stage.height;
        const startX=origin.left-stage.left+origin.width*.91,startY=origin.top-stage.top+origin.height*585/700;
        const glyphs={
          t:[38,'M0 70 C12 58 20 22 23 8 C25 -4 12 9 13 34 L11 43 L31 40 L3 43 L11 43 L9 70 C8 90 25 82 38 70'],
          h:[48,'M0 70 C18 46 29 2 20 2 C5 3 7 61 8 79 C16 32 40 32 34 65 C29 88 39 78 48 70'],
          e:[42,'M0 70 C33 59 32 35 17 44 C-3 56 2 90 23 83 C33 80 36 76 42 70'],
          m:[70,'M0 70 L9 45 L8 80 C18 27 39 36 28 79 C42 29 61 39 52 67 C46 88 61 79 70 70'],
          a:[48,'M0 70 C8 32 40 37 28 67 C14 100 -5 73 12 51 C20 40 30 43 31 47 L27 72 C24 88 39 77 48 70'],
          n:[48,'M0 70 L9 45 L7 79 C19 30 41 37 31 67 C26 88 39 78 48 70'],
          b:[48,'M0 70 C19 40 28 0 18 2 C4 6 4 64 11 77 C23 100 46 44 28 46 C18 46 21 81 48 70'],
          g:[51,'M0 70 C8 32 40 37 28 67 C14 100 -5 73 12 51 C20 40 30 43 31 47 L22 96 C14 130 -9 119 3 105 C15 93 38 85 51 70']
        };
        const word='themanabag',total=[...word].reduce((n,c)=>n+glyphs[c][0],0);
        const scale=(mobile?w*.80:w*.34)/total,x=mobile?w*.10:w*.57,y=h*(mobile?.825:.81)-70*scale;
        let d=mobile ? `M${startX} ${startY} C${w*.97} ${startY+h*.14} ${w*.94} ${y-35*scale} ${x} ${y+70*scale}` : `M${startX} ${startY} C${w*.96} ${startY+h*.05} ${w*.96} ${y-30*scale} ${w*.79} ${y-30*scale} S${x-24*scale} ${y+20*scale} ${x} ${y+70*scale}`;
        this.writing.setAttribute('d',d);
        this.connectorLength=this.writing.getTotalLength();
        let offset=0;
        for(const letter of word){
          const [advance,shape]=glyphs[letter],path=document.createElementNS('http://www.w3.org/2000/svg','path');
          path.setAttribute('d',shape);
          const length=path.getTotalLength();
          for(let j=0;j<=100;j++){const point=path.getPointAtLength(length*j/100);d+=` L${(x+(offset+point.x)*scale).toFixed(2)} ${(y+point.y*scale).toFixed(2)}`;}
          offset+=advance;
        }
        d+=` Q${x+(total+13)*scale} ${y+55*scale} ${x+(total+22)*scale} ${y+62*scale}`;
        this.writing.setAttribute('d',d);
        this.writingLength=this.writing.getTotalLength();
        this.writing.style.strokeDasharray=String(this.writingLength);
      }
      schedule() {
        if(!this.isConnected || this.frame)return;
        this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});
      }
      update() {
        if(!this.classList.contains('is-ready'))return;
        const rect=this.getBoundingClientRect(),stage=this.querySelector('.mana-stage');
        this.progress=Math.max(0,Math.min(1,((this.topOffset||0)-rect.top)/(rect.height-stage.offsetHeight)));
        const p=this.progress;
        const pull=this.ease((p-.015)/.27);
        this.threadPaths.forEach(path=>{path.style.strokeDasharray=`0 ${1000*pull} ${1000*(1-pull)} 1001`;path.style.opacity=pull===1?'0':'';});
        if(this.writing){
          const head=this.writingLength*this.ease((p-.015)/.40);
          const tail=Math.min(head,this.connectorLength*this.ease((p-.285)/.20));
          this.writing.style.strokeDasharray=`0 ${tail} ${Math.max(0,head-tail)} ${this.writingLength+1}`;
          this.writing.style.strokeDashoffset='0';
          this.writing.style.opacity=head===0?'0':'1';
        }
        const i=Math.min(this.chapters.length-1,Math.floor(p*this.chapters.length));this.activate(i);
        this.querySelector('.mana-progress').style.transform=`scaleX(${p})`;
        const reveal=this.ease((p-.82)/.11);
        this.scene.style.opacity=this.reveal?String(1-reveal):'1';
        if(this.reveal)this.reveal.style.opacity=String(reveal);
        if(rect.bottom>0 && rect.top<innerHeight && (!this.reveal || reveal<1))this.draw(p);
      }
      activate(index) {
        if(this.index===index)return;
        this.index=index;
        this.chapters.forEach((chapter,i)=>{const active=i===index;chapter.classList.toggle('is-active',active);chapter.setAttribute('aria-hidden',String(!active));chapter.inert=!active;});
        this.buttons.forEach((button,i)=>{button.classList.toggle('is-current',i===index);if(i===index)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});
      }
      ease(n) {const t=Math.max(0,Math.min(1,n));return t*t*(3-2*t);}
      go(index) {
        if(!this.classList.contains('is-ready'))return;
        const p=index===0?0:Math.min(.96,index/(this.chapters.length-1));
        const distance=this.getBoundingClientRect().top-(this.topOffset||0)+(this.offsetHeight-this.querySelector('.mana-stage').offsetHeight)*p;
        let scroller=this.parentElement;
        while(scroller && scroller!==document.body && !/(auto|scroll)/.test(getComputedStyle(scroller).overflowY))scroller=scroller.parentElement;
        const target=!scroller||scroller===document.body?window:scroller;
        target.scrollBy({top:distance,behavior:this.motion.matches?'instant':'smooth'});
      }
      draw(p) {
        const spread=this.ease((p-.035)/.23),weave=this.ease((p-.27)/.26),form=this.ease((p-.55)/.25);
        for(let i=0;i<this.points.length;i++){
          const point=this.points[i],t=(i%29)/28,si=i%375;
          const sx=(t-.5)*8.8,sy=Math.sin(t*Math.PI*2-.8)*1.12;
          const px=(si%25-12)*.177,py=(Math.floor(si/25)-7)*.177,pz=Math.sin(px*1.4+py*1.3)*.24;
          let x=i===0?sx*spread:sx,y=i===0?sy*spread:sy,z=0;
          x+=(px-x)*weave;y+=(py-y)*weave;z=pz*weave;
          x+=(point[0]-x)*form;y+=(point[1]-y)*form;z+=(point[2]-z)*form;
          const start=i===0?1.18*(1-spread)+.19*spread:.19*this.ease((spread-t*.24)/.65);
          let size=start*(1-weave)+.087*weave;
          if(i>=29)size*=this.ease((weave-.06-si/375*.45)/.45);
          if(i>=375)size*=form;
          if(point[3])size*=this.ease((form-.3)/.6);
          this.data.set([x,y,z,Math.max(.000001,size)],i*4);
        }
        const gl=this.gl;gl.useProgram(this.program);gl.bindBuffer(gl.ARRAY_BUFFER,this.instances);gl.bufferSubData(gl.ARRAY_BUFFER,0,this.data);
        gl.uniform1f(this.uniform.aspect,this.canvas.width/this.canvas.height);gl.uniform1f(this.uniform.yaw,-.25*weave+.65*form);gl.uniform1f(this.uniform.tilt,-.08*(1-form)*weave);
        const hex=getComputedStyle(this).getPropertyValue('--mana-purple').trim().replace('#','');const full=hex.length===3?hex.split('').map(x=>x+x).join(''):hex;
        const rgb=[0,2,4].map(start=>parseInt(full.slice(start,start+2),16)/255);gl.uniform3fv(this.uniform.colour,rgb.every(Number.isFinite)?rgb:[.32,.16,.5]);
        gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.drawArraysInstanced(gl.TRIANGLES,0,this.vertexCount,this.points.length);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);this.observer?.disconnect();this.cleanups?.forEach(cleanup=>cleanup());
        if(this.gl){this.gl.deleteBuffer(this.geometry);this.gl.deleteBuffer(this.instances);this.gl.deleteProgram(this.program);this.gl=null;}
        this.started=false;
      }
    }
    customElements.define('mana-scroll-story',ManaScrollStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mana-waitlist"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mana-waitlist-count')) {
  customElements.define('mana-waitlist-count', class extends HTMLElement {
    connectedCallback() {
      this.label=this.querySelector('[role="status"]');
      this.onVisible=()=>{if(!document.hidden)this.refresh();};
      document.addEventListener('visibilitychange',this.onVisible);
      this.refresh();
      this.timer=setInterval(()=>{if(!document.hidden)this.refresh();},60000);
    }
    async refresh() {
      if(this.busy)return;
      this.busy=true;
      this.abort=new AbortController();
      const timeout=setTimeout(()=>this.abort.abort(),8000);
      try {
        const response=await fetch(this.dataset.endpoint,{credentials:'omit',signal:this.abort.signal});
        if(!response.ok)throw new Error('unavailable');
        const result=await response.json();
        if(!Number.isSafeInteger(result.count)||result.count<0||!Number.isFinite(Date.parse(result.updatedAt))||Math.abs(Date.now()-Date.parse(result.updatedAt))>180000)throw new Error('unavailable');
        const text=(result.count===0?this.dataset.zero:result.count===1?this.dataset.one:this.dataset.many).replace('[count]',new Intl.NumberFormat(document.documentElement.lang||'en').format(result.count));
        if(this.label.textContent!==text)this.label.textContent=text;
        this.hidden=false;
      } catch {this.hidden=true;}
      finally {clearTimeout(timeout);this.busy=false;}
    }
    disconnectedCallback() {clearInterval(this.timer);this.abort?.abort();document.removeEventListener('visibilitychange',this.onVisible);}
  });
}

  } catch(e) { console.error(e); }
})();
})();
